import { Toaster } from "@/components/ui/toaster";
import React from "react";

import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";

import Login from "Auth/Login";

import PersonalPanel from "PersonalPanel";
import PersonalAvatars from "PersonalPanel/Avatars";
import PersonalLayout from "PersonalPanel/Layout";

import ReviewDraft from "AdminPanel/ReviewDraft";
import ReviewDlcDraft from "AdminPanel/ReviewDraft/Dlc";
import ReviewAvatar from "AdminPanel/ReviewDraft/Avatar";
import Editor from "Editor";

import FrameLayout from "AdminPanel/Frames/Layout";
import FrameDetail from "AdminPanel/Frames/Detail";
import FrameReportSummary from "AdminPanel/Frames/ReportSummary";
import FrameChangeCover from "AdminPanel/Frames/ChangeCover";

import Avatars from "AdminPanel/Avatars";
import WebImgs from "AdminPanel/WebImgs";
import TemplateLists from "AdminPanel/TemplateList";
import Ocs from "AdminPanel/Ocs";

import Page404 from "404";

import AdminPublishers from "AdminPanel/Publishers";

import RequireAdmin from "AdminPanel/RequireAdmin";

import AdminTemplateLayout from "AdminPanel/TemplateLayout";

import CommLayout from "AdminPanel/CommLayout";

import Spine from "AdminPanel/Spine";
import SpineEditor from "AdminPanel/Spine/editor";
import DraftReview from "AdminPanel/Spine/draft-review";
import SpineAvatars from "AdminPanel/SpineAvatars";
import SpineAvatarsList from "AdminPanel/SpineAvatars/SpineAvatars";
import DevTools from "AdminPanel/DevTools";
import OpsTools from "AdminPanel/OpsTools";
import Search from "AdminPanel/Search";
import PaintingRequestDetail from "AdminPanel/PaintingRequests/detail";
import AppLists from "AdminPanel/AppLists";

import DocsLayout from "docs/layout";
import MarkdownRenderer from "docs/markdown";

import { useAuthStore } from "api/swr";

const App = () => {
  return (
    <div className="w-full min-h-screem">
      <Routes>
        <Route index element={<Login />} />
        <Route path="login" element={<Login />} />

        <Route path="/" element={<RequireAuth />}>
          <Route path="personal" element={<PersonalLayout />}>
            <Route index element={<PersonalPanel />} />
            <Route
              path="templates/:tid/avatars"
              element={<PersonalAvatars />}
            />
          </Route>
          <Route path="editor/:tid" element={<Editor />} />
          <Route path="review/:tid" element={<ReviewDraft />} />
          <Route path="review/dlc/:tid" element={<ReviewDlcDraft />} />
          <Route path="review/avatar/:tid" element={<ReviewAvatar />} />
          <Route path="admin" element={<RequireAdmin />}>
            <Route path="" element={<AdminTemplateLayout />} />
            <Route path="avatars" element={<Avatars />} />
            <Route path="comm" element={<CommLayout />} />

            <Route path="publishers" element={<AdminPublishers />} />
            <Route path="ocs" element={<Ocs />} />
            <Route path="webimgs" element={<WebImgs />} />
            <Route path="template-lists" element={<TemplateLists />} />
            <Route path="frames/:id/change-cover" element={<FrameChangeCover />} />
            <Route path="frames/:id" element={<FrameLayout />}>
              <Route path="detail" element={<FrameDetail />}></Route>
              <Route
                path="report-summary"
                element={<FrameReportSummary />}
              ></Route>
            </Route>
            <Route path="search" element={<Search />} />
            <Route path="ops-tools" element={<OpsTools />} />
            <Route
              path="painting-requests/:id"
              element={<PaintingRequestDetail />}
            />
            <Route path="dev-tools" element={<DevTools />} />
            <Route path="app-lists" element={<AppLists />} />
            <Route path="spine" element={<Spine />} />
            <Route path="spine/review/:tid" element={<DraftReview />} />
            <Route path="spine/editor/:tid" element={<SpineEditor />} />
            <Route path="spine-avatars" element={<SpineAvatars />}>
              <Route index element={<SpineAvatarsList />} />
            </Route>
          </Route>
          <Route path="/docs" element={<DocsLayout />}>
            <Route path=":file" element={<MarkdownRenderer />} />
          </Route>
        </Route>
        <Route path="*" element={<Page404 />} />
      </Routes>
      <Toaster />
    </div>
  );
};

const RequireAuth = () => {
  const isLoggedIn = useAuthStore((state) => state.auth?.user);
  const location = useLocation();
  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  //TODO: ROLE LIMIT
  // console.log(location);

  return <Outlet />;
};

export default App;
